export const targetGroupOptions = [
    { short: 'teachers', long: 'OP' },
    { short: 'oop', long: 'OOP' },
    { short: 'management', long: 'Leidinggevenden' },
];

export const experienceNeededOptions = [
    { short: 'school', long: 'In opleiding' },
    { short: 'starter', long: 'Starter' },
    { short: 'experienced', long: 'Ervaren' },
    { short: 'master', long: 'Meester' },
];

export const trainingRatingOptions = [
    { short: '1', long: '1' },
    { short: '2', long: '2' },
    { short: '3', long: '3' },
    { short: '4', long: '4' },
    { short: '5', long: '5' },
    { short: '6', long: '6' },
    { short: '7', long: '7' },
    { short: '8', long: '8' },
    { short: '9', long: '9' },
    { short: '10', long: '10' },
];

export const traingingAchievedOptions = [
    { short: 'ja', long: 'Ja' },
    { short: 'nee', long: 'Nee' },
    { short: 'eerste_stap', long: 'Eerste stap gezet' },
];

export const trainingShareOptions = [
    { short: 'ja', long: 'Ja' },
    { short: 'nee', long: 'Nee' },
    { short: 'twijfel', long: 'Daar twijfel ik over' },
];

export const devDirectionOptions = [
    { short: 'organise', long: 'Organiseren van onderwijs', color: '#169AB5' },
    { short: 'develop', long: 'Ontwikkelen van onderwijs', color: '#0088C3' },
    {
        short: 'support_students',
        long: 'Ondersteunen van leren van leerlingen',
        color: '#FED230',
    },
    {
        short: 'support_colleagues',
        long: "Ondersteunen van leren van collega's",
        color: '#1E265C',
    },
    { short: 'manage', long: "Leidinggeven aan collega's", color: '#1E265C' },
    {
        short: 'general',
        long: 'Algemene trainingen',
        color: '#707070',
    },
];

export const themeOptions = [
    {
        short: 'pedagogiek',
        long: 'Pedagogiek en begeleiden',
    },
    {
        short: 'didactiek',
        long: 'Didactiek en evalueren',
    },
    {
        short: 'onderwijsinnovatie',
        long: 'Onderwijsinnovatie',
    },
    {
        short: 'ICT',
        long: 'ICT-vaardigheden',
    },
    {
        short: 'effectiviteit',
        long: 'Persoonlijke effectiviteit',
    },
    {
        short: 'vitaliteit',
        long: 'Vitaliteit',
    },
    {
        short: 'leiderschap',
        long: 'Leiderschap',
    },
    {
        short: 'professionalisering',
        long: 'Professionalisering specifieke taken',
    },
];

export const startMonthOptions = [
    { short: 1, long: 'januari' },
    { short: 2, long: 'februari' },
    { short: 3, long: 'maart' },
    { short: 4, long: 'april' },
    { short: 5, long: 'mei' },
    { short: 6, long: 'juni' },
    { short: 7, long: 'juli' },
    { short: 8, long: 'augustus' },
    { short: 9, long: 'september' },
    { short: 10, long: 'oktober' },
    { short: 11, long: 'november' },
    { short: 12, long: 'december' },
];

export const enrollmentOptions = [{ short: null, long: 'Nader te bepalen' }];
